import useSWR, { BareFetcher, SWRConfiguration, SWRResponse } from "swr";

type Config = SWRConfiguration<Data, Error, BareFetcher<Data>>;
type Data = Statistics;
type Response = SWRResponse<Data, Error>;

export default function useDailyStatistics(config?: Config): Response {
  return useSWR<Data, Error>("/statistics/daily", config);
}
